<template>
    <div class="modal" ref="modal">
        <div class="modal__shadow" v-close-popup></div>
        <div class="modal__container">
            <div class="modal__content">
                <div class="modal__close" v-close-popup v-if="addCloseButton">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M9.46585 8.01384L15.6959 1.78357C16.1014 1.37832 16.1014 0.723079 15.6959 0.317826C15.2907 -0.0874278 14.6355 -0.0874278 14.2302 0.317826L7.99992 6.5481L1.76983 0.317826C1.36439 -0.0874278 0.709336 -0.0874278 0.304083 0.317826C-0.101361 0.723079 -0.101361 1.37832 0.304083 1.78357L6.53417 8.01384L0.304083 14.2441C-0.101361 14.6494 -0.101361 15.3046 0.304083 15.7099C0.506045 15.912 0.771596 16.0136 1.03696 16.0136C1.30232 16.0136 1.56768 15.912 1.76983 15.7099L7.99992 9.47959L14.2302 15.7099C14.4323 15.912 14.6977 16.0136 14.9631 16.0136C15.2284 16.0136 15.4938 15.912 15.6959 15.7099C16.1014 15.3046 16.1014 14.6494 15.6959 14.2441L9.46585 8.01384Z"
                            fill="#00ABAA"/>
                    </svg>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { disablePageScroll, enablePageScroll, getPageScrollBarWidth } from 'scroll-lock';

export default {
    name: "Modal",
    props: {
        addCloseButton: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        const headerFixed = document.querySelector('.header__bottom._fixed');
        headerFixed && (headerFixed.style.paddingRight = getPageScrollBarWidth() + 'px');
        disablePageScroll(this.$refs.modal);
    },
    beforeDestroy() {
        const headerFixed = document.querySelector('.header__bottom._fixed');
        headerFixed && (headerFixed.style.paddingRight = '0');
        enablePageScroll(this.$refs.modal);
    },
}
</script>

<style lang="scss">
.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    overflow: auto;

    &__shadow {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(5, 5, 5, .4);
    }

    &__container {
        pointer-events: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: 100vh;
        padding: 10px;
        @media all and (-ms-high-contrast: none) {
            height: 100vh;
        }
    }

    &__content {
        position: relative;
        pointer-events: auto;
    }

    &__close {
        position: absolute;
        z-index: 1;
        right: 15px;
        top: 15px;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
    }
}
</style>
